"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var prop_types_1 = __importDefault(require("prop-types"));

var react_1 = __importDefault(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var polished_1 = require("polished");

var sportnet_utilities_1 = require("sportnet-utilities");

var utilities_1 = require("@sportnet/ui/lib/Themes/utilities");

var Header_1 = __importDefault(require("../../components/Header"));

var format_1 = __importDefault(require("date-fns/format"));

var sk_1 = __importDefault(require("date-fns/locale/sk"));

var List_1 = require("../ArticleList/List");

var DATE_WIDTH = 65;
var Events = styled_components_1["default"]('section')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: grid;\n  grid-template-columns: ", ";\n  grid-gap: ", ";\n"], ["\n  display: grid;\n  grid-template-columns: ", ";\n  grid-gap: ", ";\n"])), "repeat(auto-fill, minmax(" + List_1.MINMAX_ARTICLE_WIDTH + "px, 1fr))", function (_a) {
  var theme = _a.theme;
  return polished_1.rem(theme.grid.gutterWidth);
});
var Title = styled_components_1["default"]('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-weight: bold;\n  color: ", ";\n  margin-bottom: 0.1em;\n"], ["\n  font-weight: bold;\n  color: ", ";\n  margin-bottom: 0.1em;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.app.textColor;
});
var EventLink = styled_components_1["default"]('a')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  text-decoration: none;\n  :hover ", " {\n    text-decoration: underline;\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  text-decoration: none;\n  :hover ", " {\n    text-decoration: underline;\n  }\n"])), Title);
var Date = styled_components_1["default"]('div')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-size: ", ";\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  background: ", ";\n  color: ", ";\n  height: ", "px;\n  width: ", "px;\n  border-radius: ", ";\n  line-height: 1;\n  margin-right: 0.5em;\n"], ["\n  font-size: ", ";\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  background: ", ";\n  color: ", ";\n  height: ", "px;\n  width: ", "px;\n  border-radius: ", ";\n  line-height: 1;\n  margin-right: 0.5em;\n"])), polished_1.rem(30), function (_a) {
  var theme = _a.theme;
  return theme.color.primary;
}, function (_a) {
  var theme = _a.theme;
  return utilities_1.emphasizeColor(1, theme.color.primary);
}, DATE_WIDTH, DATE_WIDTH, function (_a) {
  var theme = _a.theme;
  return theme.largeBorderRadius;
});
var Day = styled_components_1["default"]('div')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  font-weight: bold;\n"], ["\n  font-weight: bold;\n"])));
var Month = styled_components_1["default"]('div')(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  font-size: 0.4em;\n"], ["\n  font-size: 0.4em;\n"])));
var Detail = styled_components_1["default"]('div')(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  font-size: ", ";\n"], ["\n  font-size: ", ";\n"])), polished_1.rem(16));
var Subtitle = styled_components_1["default"]('div')(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  font-size: 0.75em;\n  color: ", ";\n"], ["\n  font-size: 0.75em;\n  color: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return polished_1.rgba(theme.app.textColor, 0.75);
});

var C = function C(_a) {
  var header = _a.data.header,
      data = _a.data,
      renderEmpty = _a.renderEmpty;
  var events = sportnet_utilities_1.getProp(data, ['data', 'eventFilter', 'events'], []);

  if (!events.length && renderEmpty) {
    return renderEmpty(data.type);
  }

  var items = [];
  events.forEach(function (event) {
    return event.dates.forEach(function (date) {
      return items.push(__assign({
        date: date
      }, event));
    });
  });
  items = items.slice(0, 6);
  var link = '/';

  if (events.length > 0) {
    var filters = sportnet_utilities_1.getProp(data, ['eventFilter'], []);
    var params_1 = {
      calendars: [],
      dateFrom: format_1["default"](events[0].dates[0].from, 'YYYY-MM-DD')
    };
    filters.forEach(function (f) {
      if (f.type === 'calendar') {
        params_1.calendars = f.value.join('|');
      }
    });
    var appSpace = events[0] ? events[0].appspace : '';
    link = "https://public.calendar.sportnet.online/" + appSpace + "?" + sportnet_utilities_1.objectToParams(params_1);
  }

  return react_1["default"].createElement(react_1["default"].Fragment, null, header && react_1["default"].createElement(Header_1["default"], {
    renderShowmoreLink: function renderShowmoreLink(linkProps) {
      return react_1["default"].createElement("a", __assign({
        href: link,
        target: "_blank"
      }, linkProps), linkProps.children);
    }
  }, header), react_1["default"].createElement(Events, null, items.map(function (_a) {
    var date = _a.date,
        event = __rest(_a, ["date"]);

    return react_1["default"].createElement(EventLink, {
      href: "https://public.calendar.sportnet.online/" + event.appspace + "/" + event._id + "?dateFrom=" + format_1["default"](date.from, 'YYYY-MM-DD'),
      target: "_blank"
    }, react_1["default"].createElement(Date, null, react_1["default"].createElement(Day, null, format_1["default"](date.from, 'D')), react_1["default"].createElement(Month, null, format_1["default"](date.from, 'MMMM', {
      locale: sk_1["default"]
    }).toLocaleLowerCase())), react_1["default"].createElement(Detail, null, react_1["default"].createElement(Title, null, event.title), react_1["default"].createElement(Subtitle, null, date.allDayEvent ? 'Celý deň' : format_1["default"](date.from, 'HH:mm') + " - " + format_1["default"](date.to, 'HH:mm'))));
  })));
};

C.propTypes = {
  data: prop_types_1["default"].shape({}).isRequired
};
exports["default"] = C;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;